
import SeedLoginPage from '../page/login/SeedLoginPage';
import { ROUTE_TYPE_ANTI_PRIVATE, ROUTE_TYPE_PRIVATE, ROUTE_TYPE_CRUD } from './route-constants';
import SeedHomePage from '../page/home/SeedHomePage';
import SeedSettingsPage from '../page/settings/SeedSettingsPage';
import SeedRegisterPage from '../page/register/SeedRegisterPage';
import SeedProfilePage from '../page/profile/SeedProfilePage';
import SeedChartsPage from '../page/charts/SeedChartsPage';
import { sampleCrudCRUDOptions, sampleCrudRoutes } from '../page/crud/sample/sample-crud-routes';
import SeedRegisterDialog from '../page/register/SeedRegisterDialog';
import SeedWidgetsPage from '../page/widgets/SeedWidgetsPage';
import SeedMySnackbarPage from '../page/widgets/subpage/SeedMySnackbarPage';
import SeedMyLinearProgressPage from '../page/widgets/subpage/SeedMyLinearProgressPage';

const seedRoutes = [
  {
    type: ROUTE_TYPE_ANTI_PRIVATE,
    path: '/login',
    titleId: 'seed.login.title',
    exact: true,
    Component: SeedLoginPage,
  },
  {
    type: ROUTE_TYPE_ANTI_PRIVATE,
    path: '/register',
    titleId: 'seed.register.title',
    exact: true,
    Component: SeedRegisterPage,
    ComponentDialog: SeedRegisterDialog,
    componentType: 'routeDialog',
  },
  {
    type: ROUTE_TYPE_PRIVATE,
    path: '/',
    titleId: 'seed.home.title',
    exact: true,
    Component: SeedHomePage,
  },
  {
    type: ROUTE_TYPE_PRIVATE,
    path: '/settings',
    titleId: 'seed.settings.title',
    exact: true,
    Component: SeedSettingsPage,
  },
  {
    type: ROUTE_TYPE_PRIVATE,
    path: '/profile',
    titleId: 'seed.profile.title',
    exact: true,
    Component: SeedProfilePage,
  },
  {
    type: ROUTE_TYPE_PRIVATE,
    path: '/charts',
    titleId: 'seed.charts.title',
    exact: true,
    Component: SeedChartsPage,
  },
  {
    type: ROUTE_TYPE_PRIVATE,
    path: '/widgets',
    titleId: 'seed.widgets.title',
    exact: true,
    Component: SeedWidgetsPage,
  },
  {
    type: ROUTE_TYPE_PRIVATE,
    path: '/widgets/my-snackbar',
    titleId: 'seed.widgets.MySnackbar.title',
    exact: true,
    Component: SeedMySnackbarPage,
  },
  {
    type: ROUTE_TYPE_PRIVATE,
    path: '/widgets/my-linearprogress',
    titleId: 'seed.widgets.MyLinearProgress.title',
    exact: true,
    Component: SeedMyLinearProgressPage,
  },
  {
    type: ROUTE_TYPE_CRUD,
    routes: sampleCrudRoutes,
    crudOptions: sampleCrudCRUDOptions,
  },
];

export default seedRoutes;
